import React, { useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  CircularProgress,
} from '@mui/material';
import { fetchStats } from '../store/slices/statsSlice';

function Dashboard() {
  const dispatch = useDispatch();
  const { stats, loading } = useSelector((state) => state.stats);
  const isInitialMount = useRef(true);

  const loadStats = useCallback(async () => {
    if (!isInitialMount.current) return;
    
    try {
      await dispatch(fetchStats()).unwrap();
    } catch (error) {
      console.error('Failed to load stats:', error);
    }
  }, [dispatch]);

  useEffect(() => {
    loadStats();
    return () => {
      isInitialMount.current = false;
    };
  }, [loadStats]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          fontWeight: 600,
          color: 'primary.main',
          mb: 4
        }}
      >
        Dashboard
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Card 
            elevation={2}
            sx={{ 
              height: '100%',
              borderRadius: 2,
              '&:hover': {
                boxShadow: 3,
              }
            }}
          >
            <CardHeader 
              title="Total Domains" 
              titleTypographyProps={{
                variant: 'h6',
                fontWeight: 600,
                color: 'primary.main'
              }}
            />
            <Divider />
            <CardContent>
              <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                {stats?.totalDomains || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card 
            elevation={2}
            sx={{ 
              height: '100%',
              borderRadius: 2,
              '&:hover': {
                boxShadow: 3,
              }
            }}
          >
            <CardHeader 
              title="Total URLs" 
              titleTypographyProps={{
                variant: 'h6',
                fontWeight: 600,
                color: 'primary.main'
              }}
            />
            <Divider />
            <CardContent>
              <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                {stats?.totalUrls || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card 
            elevation={2}
            sx={{ 
              height: '100%',
              borderRadius: 2,
              '&:hover': {
                boxShadow: 3,
              }
            }}
          >
            <CardHeader 
              title="Total Redirects" 
              titleTypographyProps={{
                variant: 'h6',
                fontWeight: 600,
                color: 'primary.main'
              }}
            />
            <Divider />
            <CardContent>
              <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                {stats?.totalRedirects || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard; 